<app-pagination-footer-template
    [paginationParameters]="createFieldInterventionService.paginationParameters()"
    [searchDisabled]="!createFieldInterventionService.activeLayers().length"
    [selectedEntitiesNumber]="createFieldInterventionService.selectedEntitiesNumber()"
    [selectedLayerNumber]="createFieldInterventionService.selectedLayerNumber()"
    [(forceReset)]="createFieldInterventionService.forceReset"
    (handleSearch)="handleSearch($event)"
    (onPageChange)="createFieldInterventionService.onPageChange($event)"
    (paginator)="onPaginatorChange($event)">
    @if (createFieldInterventionService.isSubmitting()) {
        <app-loading
            class="mr-4"
            size="20"
            [hasMessage]="false"
            [strokeWidth]="3" />
    } @else {
        <div class="flex items-start justify-end px-4">
            <app-button
                [disabled]="!createFieldInterventionService.selectedLayerNumber()"
                [icon]="['fas', 'check']"
                [label]="'validateSelection' | transloco"
                [type]="ButtonType.PRIMARY"
                (onClick)="validateSelection()" />
        </div>
    }
</app-pagination-footer-template>
